import { EmployerConstants } from './employer.constants'
import { IEmployerAction, IEmployerState } from './employer.types'

export const initialEmployerState: IEmployerState = {
  industry: null,
  occupation: null,
  primaryBusiness: '',
  address1: '',
  address2: '',
  city: null,
  state: null,
  zipCode: '',
  county: null,
  country: null,
  phoneNumber: '',
  phoneType: null,
}

export function employerReducer(state: IEmployerState = initialEmployerState, action: IEmployerAction): IEmployerState {
  switch (action.type) {
    case EmployerConstants.SET_INDUSTRY:
      return { ...state, industry: action.industry }
    case EmployerConstants.SET_OCUPATION:
      return { ...state, occupation: action.occupation }
    case EmployerConstants.SET_PRIMARY_BUSINESS:
      return { ...state, primaryBusiness: action.primaryBusiness }
    case EmployerConstants.SET_ADDRESS1:
      return { ...state, address1: action.address1 }
    case EmployerConstants.SET_ADDRESS2:
      return { ...state, address2: action.address2 }
    case EmployerConstants.SET_CITY:
      return { ...state, city: action.city }
    case EmployerConstants.SET_STATE:
      return { ...state, state: action.state }
    case EmployerConstants.SET_ZIPCODE:
      return { ...state, zipCode: action.zipCode }
    case EmployerConstants.SET_COUNTY:
      return { ...state, county: action.county }
    case EmployerConstants.SET_COUNTRY:
      return { ...state, country: action.country }
    case EmployerConstants.SET_PHONENUMBER:
      return { ...state, phoneNumber: action.phoneNumber }
    case EmployerConstants.SET_PHONETYPE:
      return { ...state, phoneType: action.phoneType }
    case EmployerConstants.SET_EMPLOYER:
      return { ...state, ...action.employer }
    case EmployerConstants.RESET_EMPLOYER_STATE:
      return {
        ...initialEmployerState,
      }
    default:
      return state
  }
}
